module.exports = {"371171003":"奎山街道","371171007":"北京路街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/371171.json
// module id = 1572
// module chunks = 0